import React, { useEffect, useContext, useState } from "react"
import DashboardSupervisor from "../Homepage/DashboardSupervisor"
import use2FAPending from "../../hooks/use2FAPending"
import { UserContext } from "../../context/userContext"
import { useNavigate } from "react-router-dom"

export default function Homepage() {
  const userCtx = useContext(UserContext)
  const navigate = useNavigate()
  const currentUserRole = Number(userCtx.session.user.staff_role) || null
  const shouldRedirect = use2FAPending()
  const [isCheckingRedirect, setIsCheckingRedirect] = useState(true)

  useEffect(() => {
    let isMounted = true

    const checkRedirect = async () => {
      const hasRedirected = localStorage.getItem("hasRedirected")

      if (shouldRedirect && !hasRedirected) {
        localStorage.setItem("hasRedirected", "true")
        navigate("/account/2fa/settings")
      } else if (isMounted) {
        setIsCheckingRedirect(false)
      }
    }

    checkRedirect()

    return () => {
      isMounted = false
    }
  }, [shouldRedirect, navigate])

  if (isCheckingRedirect) return null
  if (!currentUserRole) return null

  return <DashboardSupervisor />
}
